const burnley = [
  {
    id: 0,
    pais: "inglaterra",
    liga: "premier-league",
    time: "burnley",
    nome: "Burnley 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: ["burnley", "the claret", "burnley 2025", "2025 burnley", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/burnley/25-26-01/uni0.jpg",
      "/images/inglaterra/premier-league/burnley/25-26-01/uni1.jpg",
      "/images/inglaterra/premier-league/burnley/25-26-01/uni2.jpg",
      "/images/inglaterra/premier-league/burnley/25-26-01/uni3.jpg",
      "/images/inglaterra/premier-league/burnley/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "burnley",
    nome: "Burnley 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: ["burnley", "the claret", "burnley 2025", "2025 burnley", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/burnley/25-26-02/uni0.png",
      "/images/inglaterra/premier-league/burnley/25-26-02/uni1.png",
      "/images/inglaterra/premier-league/burnley/25-26-02/uni2.png",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "burnley",
    nome: "Burnley 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: ["burnley", "the claret", "burnley 2025", "2025 burnley", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/burnley/25-26-03/uni0.png",
      "/images/inglaterra/premier-league/burnley/25-26-03/uni1.png",
    ],
  },
];

export default burnley;
